import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../utils/api';
import { toast } from 'react-toastify';
import { setCustomerRefresh } from './customerSlice';


// Thunk to fetch top topcategories
export const addToScheduleThunk = createAsyncThunk(
    'schedule/addToScheduleThunk',
    async (data, { rejectWithValue,dispatch }) => {
        try {
            const response = await api.addToSchedule(data);
            toast.success("Products added to schedule successfully");
            dispatch(setCustomerRefresh())
            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || "error of adding product into schedule");
        }
    }
);


export const upadteScheduleCart = createAsyncThunk(
    'cart/upadteScheduleCart',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.updateSchedule(data);
            // dispatch(setCartRefresh())
            return response.status;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getAllScheduleProductThunk = createAsyncThunk(
    'schedule/getAllScheduleProductThunk',
    async (id, { rejectWithValue,dispatch }) => {
        try {
            const response = await api.getScheduleDetails(id);
             dispatch(setCustomerRefresh())
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const deleteProductfromScheduleThunk = createAsyncThunk(
    'cart/deleteProductfromSchedule',
    async (id, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deleteScheduleProducts(id)
            dispatch(setScheduleRefresh())
            toast.success('Product deleted successfully')
        } catch (err) {
            console.log(err);
            toast.error('something went wrong')
        }
    }
)

export const uploadschedulepoThunk = createAsyncThunk(
    'schedule/uploadschedulepoThunk',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.scheduleCheckout(data);
            toast.success("Products uploaded to schedule successfully");

            return response.status;
        } catch (error) {
            console.log(error);
            toast.error("error of uploading product into schedule");
        }
    }
);






const cartSlice = createSlice({
    name: 'schedule',
    initialState: {
        scheduleData: [],
        addScheduleloading: false,
        error: null,
        refresh: false
    },
    reducers: {
        setscheduleData: (state, action) => {
            state.scheduleData = action.payload
        },
        setScheduleRefresh: (state, action) => {
            state.refresh = !state.refresh
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(addToScheduleThunk.pending, (state) => {
                state.addScheduleloading = true;
            })
            .addCase(addToScheduleThunk.fulfilled, (state, action) => {
                state.addScheduleloading = false;
            })
            .addCase(addToScheduleThunk.rejected, (state, action) => {
                state.addScheduleloading = false;
            })

            //getCartdetails
            .addCase(getAllScheduleProductThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllScheduleProductThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.scheduleData = action.payload;
            })
            .addCase(getAllScheduleProductThunk.rejected, (state, action) => {
                state.loading = false;
            });
    },
});

export const { setProductPage, setscheduleData, setScheduleRefresh } = cartSlice.actions
export default cartSlice.reducer;

